import { useQuery } from 'react-query';
import { apiClient, endpoints } from '../api/client';

export interface SystemStatus {
  total_definitions: number;
  active_definitions?: number;
  /** Enabled definitions whose latest finished Collector task completed with full URL success */
  verified_definitions?: number;
  total_marketplaces: number;
  /** Mean parse success (0–1) across enabled definitions that have crawl results, or null */
  average_success_rate: number | null;
  definitions_needing_maintenance: number;
  last_updated: string;
}

export const useSystemStatus = (enabled: boolean = true) => {
  return useQuery<SystemStatus>(
    'systemStatus',
    async () => {
      const response = await apiClient.get(endpoints.systemStatus + '/dashboard');
      return response.data;
    },
    {
      enabled,
      refetchInterval: enabled ? 60000 : false,
      staleTime: 30000,
      cacheTime: 300000,
    }
  );
};
